import { useEffect, useState } from 'react';
import { NavLink, Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MdChatBubbleOutline, MdCalendarToday, MdAlarm, MdGridView, MdWbSunny, MdWifiOff, MdPersonOutline } from 'react-icons/md';
import useSocket from '../hooks/useSocket';
import useViewport from '../mobile/useViewport';
import { previewMode } from '../mobile/preview';
import BrandLogo from '../mobile/BrandLogo';
import { segnalaPresenza } from '../api/notifiche';

const tabs = [['/', 'Oggi', MdWbSunny], ['/chat', 'Chat', MdChatBubbleOutline], ['/calendar', 'Agenda', MdCalendarToday], ['/reminders', 'Promemoria', MdAlarm], ['/more', 'Altro', MdGridView]];
const extra = ['/sessions', '/settings', '/automations', '/address-book', '/notifiche'];

// Mentre l'app è in primo piano i messaggi non suonano (come WhatsApp) e il
// numerino sull'icona si azzera; toccando una notifica con l'app già aperta il
// service worker chiede di aprire quella chat (04/10/2026).
function useNotifiche(attivo) {
  const navigate = useNavigate();
  useEffect(() => {
    if (!attivo) return undefined;
    const segnala = () => {
      const visibile = document.visibilityState === 'visible';
      segnalaPresenza(visibile).catch(() => {});
      if (visibile) navigator.clearAppBadge?.()?.catch?.(() => {});
    };
    segnala();
    const ogni = setInterval(() => { if (document.visibilityState === 'visible') segnala(); }, 30000);
    document.addEventListener('visibilitychange', segnala);
    return () => { clearInterval(ogni); document.removeEventListener('visibilitychange', segnala); };
  }, [attivo]);
  useEffect(() => {
    const sw = navigator.serviceWorker;
    if (!sw) return undefined;
    const apri = e => {
      if (e.data?.tipo !== 'apri') return;
      const url = new URL(e.data.url, window.location.origin);
      navigate(url.pathname + url.search);
    };
    sw.addEventListener('message', apri);
    return () => sw.removeEventListener('message', apri);
  }, [navigate]);
}

export default function Layout({ children }) {
  useSocket();
  useViewport();
  const { pathname } = useLocation();
  const selected = useSelector(state => state.messages.selectedContact);
  const user = useSelector(state => state.auth.user);
  useNotifiche(!!user && !previewMode);
  const [online, setOnline] = useState(navigator.onLine);
  const conversation = pathname === '/chat' && !!selected;
  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener('online', update); window.addEventListener('offline', update);
    return () => { window.removeEventListener('online', update); window.removeEventListener('offline', update); };
  }, []);
  useEffect(() => { document.querySelector('.mobile-content')?.scrollTo(0, 0); }, [pathname]);
  return <div className={`mobile-app ${conversation ? 'conversation-active' : ''} ${pathname === '/chat' ? 'chat-page' : ''}`}>
    <a href="#main-content" className="skip-link">Vai al contenuto</a>
    <header className="mobile-topbar"><Link to="/" className="wordmark" aria-label="wozzap.it Home"><BrandLogo /></Link><Link to="/settings" className="profile-link" aria-label={`Profilo ${user?.first_name || user?.username || ''}`}><MdPersonOutline size={22} /></Link></header>
    {previewMode && <div className="preview-banner" role="status">Anteprima · dati di esempio · nessun invio reale <a href="/?live=1">Esci</a></div>}
    {!online && <div className="offline-banner" role="status"><MdWifiOff /> Sei offline. Le operazioni richiedono una connessione.</div>}
    <main id="main-content" className="mobile-content" tabIndex={-1}>{children}</main>
    <nav className="mobile-tabs" aria-label="Navigazione principale">{tabs.map(([to, label, Icon]) => <NavLink end={to === '/'} key={to} to={to} className={({ isActive }) => `mobile-tab ${isActive || (to === '/more' && extra.some(route => pathname.startsWith(route))) ? 'active' : ''}`}><span className="tab-icon"><Icon size={23} aria-hidden="true" /></span><span>{label}</span></NavLink>)}</nav>
  </div>;
}
